import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { mergeWithServer, hydrateFromServer, forgetSession } = useCart();

  useEffect(() => {
    const token = localStorage.getItem("aperture_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      // Warm session on reload — pull the saved cart into local state so the
      // user picks up their cart on any device they're signed in on.
      hydrateFromServer(token);
    }).catch(() => {
      localStorage.removeItem("aperture_token");
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("aperture_token", r.data.token);
    setUser(r.data.user);
    // Merge the guest cart from localStorage into the user's saved cart, then
    // re-hydrate local state from the server response.
    await mergeWithServer(r.data.token);
    return r.data.user;
  };
  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("aperture_token", r.data.token);
    setUser(r.data.user);
    await mergeWithServer(r.data.token);
    return r.data.user;
  };
  const refresh = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data); return r.data; } catch { return null; }
  };
  const logout = () => {
    localStorage.removeItem("aperture_token");
    setUser(null);
    forgetSession();
  };

  return <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
